"use client";

import { Ear, Globe, Lock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Mission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const commitments = [{
    icon: Lock,
    title: "Privacy as a Standard",
    description: "Your aesthetic journey is deeply personal. We provide a private, concierge environment where your comfort and discretion are prioritized above all else."
  }, {
    icon: Globe,
    title: "Refined Facial Balancing",
    description: "We move beyond simple wrinkle reduction. Our approach focuses on restoring symmetry and proportion to enhance your unique, natural features."
  }, {
    icon: Ear,
    title: "Preventative Expertise",
    description: "Whether addressing early signs of aging or maintaining your glow, our clinical team provides tailored, evidence-based care for long-term results."
  }];
  return <section data-section-id="18962" id="our-mission" className="dark bg-background py-28 md:py-40">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div ref={ref} className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {}
          <div className={`lg:col-span-5 transition-all duration-[900ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-primary mb-6">
              Our Mission
            </p>
            <h2 className="font-default text-foreground text-4xl md:text-5xl lg:text-[3.2rem] leading-[1.1] tracking-tight font-normal mb-8">
              Refined beauty,{" "}
              <em className="italic font-normal text-primary">effortlessly</em> balanced.
            </h2>
            <p className="font-default text-muted-foreground text-lg md:text-xl leading-relaxed">At Ideal Image Aesthetics and Wellness, LLC we believe in the art of subtle enhancement. Our mission is to provide expert facial balancing that honors your natural beauty while supporting your confidence.</p>
          </div>

          {}
          <div className="lg:col-span-7 lg:pl-4">
            {commitments.map((item, i) => {
            const Icon = item.icon;
            return <div key={i} data-index={i} className={`transition-all duration-[900ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: isVisible ? `${(i + 1) * 80}ms` : "0ms"
            }}>
                  {i > 0 && <div className="my-8 h-px w-full bg-border" />}
                  <div className="flex gap-6 md:gap-8">
                    <div className="flex-shrink-0 pt-1">
                      <Icon className="size-7 text-primary" strokeWidth={1.5} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-default text-foreground text-lg md:text-xl font-medium tracking-tight mb-3">
                        {item.title}
                      </h3>
                      <p className="font-default text-muted-foreground text-base md:text-[1.05rem] leading-[1.7]">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}